<template>
  <a-layout>
    <a-tabs v-model="activeKey" style="margin-top: -4px">
      <a-tab-pane key="unArrange" :tab="$t('tab.unArrangedOrder')" style="margin-top: -14px">
        <un-arrange ref="unArrange" @detailsSelected="detailsSelected"/>
      </a-tab-pane>
      <a-tab-pane key="arranged" :tab="$t('tab.arrangedOrder')" forceRender style="margin-top: -14px">
        <arranged ref="arranged" :orderType="orderType" @refreshUnArranged="refreshUnArranged" @rowClick="rowClick"/>
      </a-tab-pane>
      <a-space slot="tabBarExtraContent">
        <vxe-button content="button.refresh" icon="vxe-icon-refresh" size="mini" status="primary" @click="refresh"/>
        <vxe-button v-if="activeKey==='arranged'" content="button.addLoadingOrder" size="mini" status="primary" @click="addOrder"/>
        <vxe-button v-if="activeKey==='unArrange'" content="button.addLoadingDetail" size="mini" status="primary" @click="addDetail"/>
      </a-space>
    </a-tabs>
  </a-layout>
</template>

<script>
import UnArrange from '@/views/delivery/delivery_arrange/UnArrange.vue'
import Arranged from '@/views/delivery/delivery_arrange/Arranged.vue'
import { LoadingOrder } from '@/api/dto/order/LoadingOrder'
import { OrderType } from '@/api/dto/common/OrderType'

export default {
    name: 'DeliveryArrange',
    components: {
      Arranged,
      UnArrange
    },
    data() {
      return {
        activeKey: 'unArrange',
        order: new LoadingOrder(),
        orderType: new OrderType(this.queryParam.value.business.orderType)
      }
    },
    props: {
      queryParam: {
        type: Object,
        default: null
      }
    },
    methods: {
      addOrder() {
        this.$refs.arranged.addOrder()
      },
      addDetail() {
        this.$refs.unArrange.addDetail()
      },
      detailsSelected(details) {
        this.activeKey = 'arranged'
        this.$refs.arranged.addDetail(details)
      },
      refreshUnArranged() {
        this.$refs.unArrange.refresh()
      },
      refresh() {
        this.$refs[this.activeKey].refresh()
      },
      rowClick(no) {
        this.$refs.unArrange.loadingOrderNo = no
      }
    }
  }
</script>